// Copyright (c) 2026 Goffy. All Rights Reserved.

import { t } from '@/i18n';
import type { RsvpStatusOrInvited } from './types';

/** Localized label for an RSVP status (including the implicit "invited" state). */
export const rsvpStatusLabel = (status: RsvpStatusOrInvited | undefined): string => {
  switch (status) {
    case 'accepted':
      return t('rsvp.statusAccepted');
    case 'declined':
      return t('rsvp.statusDeclined');
    case 'tentative':
      return t('rsvp.statusTentative');
    default:
      return t('rsvp.statusInvited');
  }
};

/** Format an ISO-8601 UTC tee time in the viewer's locale/timezone. Falls back to the raw string. */
export const formatTeeTime = (teeTimeUtc: string | undefined): string => {
  if (!teeTimeUtc) return '';
  const date = new Date(teeTimeUtc);
  if (Number.isNaN(date.getTime())) return teeTimeUtc;
  try {
    return date.toLocaleString(undefined, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return date.toISOString();
  }
};

/** Short relative-ish timestamp for "responded {time}". Falls back to the raw string. */
export const formatRespondedAt = (respondedAtUtc: string | undefined): string => {
  if (!respondedAtUtc) return '';
  const date = new Date(respondedAtUtc);
  if (Number.isNaN(date.getTime())) return respondedAtUtc;
  try {
    return date.toLocaleString(undefined, {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return date.toISOString();
  }
};
